import { observer } from "mobx-react-lite";
import { getUpcomingCalendarMenuContentList } from "@/domains/calendar/getUpcomingCalendarMenuContentList";
import {
  MDSActionMenuDropdown,
  MDSMenuDropdownSlotName,
  MDSIconButton,
  MDSIconKind,
  MDSIconButtonSize,
  MDSMenuContentItemKind,
  MDSMenuContentList,
} from "@/mds";
import { useAppStore } from "@/store";
import { useMemo, useState } from "react";
import { NotesListPageConnectCalendarLaterModal } from "@/pages/notes/components/notes-list-page-connect-calendar-later-modal";

export const NotesListPageListUpcomingEventsHeaderButtons = observer(() => {
  const { store } = useAppStore();

  const [isConnectCalendarLaterModalOpen, setIsConnectCalendarLaterModalOpen] = useState(false);
  const hasCalendarConnections = store.spaceAccountCalendarConnections.size > 0;
  const upcomingEvents = store.spaceAccountCalendarEvents.upcomingEvents;
  const calendarDropdownContentList: MDSMenuContentList = getUpcomingCalendarMenuContentList({
    upcomingEvents,
    createNoteUsingCalendarEventId: ({ noteId, calendarEventId }) =>
      store.notes.createNoteUsingCalendarEventId({ noteId, calendarEventId }),
    navigateToNote: ({ noteId, openInSameTab }: { noteId: string; openInSameTab: boolean }) =>
      store.navigation.goToNote({ noteId, openInSameTab }),
    store,
  });

  const moreDropdownContentList: MDSMenuContentList = useMemo(
    () =>
      hasCalendarConnections
        ? [
            {
              id: "calendar-settings",
              kind: MDSMenuContentItemKind.Item,
              label: "Calendar settings",
              icon: MDSIconKind.Settings,
              onClick: () => store.navigation.goToIntegrationsCalendar(),
            },
          ]
        : [
            {
              id: "hide-calendar-events",
              kind: MDSMenuContentItemKind.Item,
              label: "Hide this section",
              icon: MDSIconKind.EyeSlash,
              onClick: () => {
                setIsConnectCalendarLaterModalOpen(true);
              },
            },
          ],
    [hasCalendarConnections, store.navigation]
  );

  return (
    <>
      {isConnectCalendarLaterModalOpen && (
        <NotesListPageConnectCalendarLaterModal
          isOpen={isConnectCalendarLaterModalOpen}
          handleClose={() => setIsConnectCalendarLaterModalOpen(false)}
        />
      )}
      {hasCalendarConnections && calendarDropdownContentList.length > 0 && (
        <MDSActionMenuDropdown contentList={calendarDropdownContentList} placement="bottom right">
          <MDSIconButton
            slot={MDSMenuDropdownSlotName.Trigger}
            iconKind={MDSIconKind.Calendar}
            size={MDSIconButtonSize.Small}
          />
        </MDSActionMenuDropdown>
      )}
      <MDSActionMenuDropdown contentList={moreDropdownContentList} placement="bottom right">
        <MDSIconButton
          slot={MDSMenuDropdownSlotName.Trigger}
          iconKind={MDSIconKind.More}
          size={MDSIconButtonSize.Small}
        />
      </MDSActionMenuDropdown>
    </>
  );
});
